var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarrierActions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_410_24",
    "data-name": "Component 410 \\u2013 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4623",
    "data-name": "Rectangle 4623",
    transform: "translate(28) rotate(90)",
    fill: "#fff",
    stroke: "#e5e5e6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 27,
    rx: 3.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "more-horizontal",
    transform: "translate(25.377 4) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_698",
    "data-name": "Ellipse 698",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(9 11.377)",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_699",
    "data-name": "Ellipse 699",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(14 11.377)",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_700",
    "data-name": "Ellipse 700",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(4 11.377)",
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrierActions);
export default __webpack_public_path__ + "static/media/carrier-actions.5229b398c2a7c19b104f6f8209faa45a.svg";
export { ForwardRef as ReactComponent };